import {
    createAsyncAction,
    createStandardAction,
} from "typesafe-actions";

import * as firebase from 'firebase/app';

export const authStateChanged = createStandardAction('AUTH_STATE_CHANGED')<firebase.User | null>();

export const logIn = createAsyncAction(
    'LOG_IN_REQUEST',
    'LOG_IN_SUCCESS',
    'LOG_IN_FAILURE',
)<void, void, Error>();



// WEBPACK FOOTER //
// ./src/actions/authActions.ts